export enum KNOWN_PAGES {
  SIGNUP_FINISH_TRIAL = 'signupFinishTrial',
  SIGNUP_FINISH = 'signupFinish',
  EMAIL_VERIFY = 'emailVerify'
}
